import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { AGENCY, waLink } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

export const SiteFooter = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#000000] text-[#FAFAF7] noise">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20 relative z-[2]">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img src="/logo-white.png" alt="ROMACASA Intermediazioni Immobiliari" className="h-12 w-auto mb-5" data-testid="footer-logo" />
            <p className="text-[#8A94A0] font-light leading-relaxed text-sm max-w-xs">{t("foot.desc")}</p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#E8E8E8] mb-5">{t("foot.esplora")}</p>
            <nav className="flex flex-col gap-3 text-sm text-[#DCE2EA]">
              <Link data-testid="footer-link-immobili" to="/immobili" className="hover:text-[#E8E8E8] transition-colors">{t("foot.tutti")}</Link>
              <Link data-testid="footer-link-vendita" to="/immobili?contract=vendita" className="hover:text-[#E8E8E8] transition-colors">{t("foot.vendita")}</Link>
              <Link data-testid="footer-link-affitto" to="/immobili?contract=affitto" className="hover:text-[#E8E8E8] transition-colors">{t("foot.affitto")}</Link>
              <Link data-testid="footer-link-prestigio" to="/immobili?category=prestigio" className="hover:text-[#E8E8E8] transition-colors">{t("foot.prestigio")}</Link>
              <Link data-testid="footer-link-commerciali" to="/immobili?category=commerciali" className="hover:text-[#E8E8E8] transition-colors">{t("foot.commerciali")}</Link>
              <Link data-testid="footer-link-cantieri" to="/immobili?category=cantieri" className="hover:text-[#E8E8E8] transition-colors">{t("foot.cantieri")}</Link>
              <Link data-testid="footer-link-mappa" to="/mappa" className="hover:text-[#E8E8E8] transition-colors">{t("foot.mappa")}</Link>
              <Link data-testid="footer-link-blog" to="/blog" className="hover:text-[#E8E8E8] transition-colors">{t("foot.blog")}</Link>
              <Link data-testid="footer-link-faq" to="/faq" className="hover:text-[#E8E8E8] transition-colors">{t("foot.faq")}</Link>
            </nav>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-[#E8E8E8] mb-5">{t("foot.contatti")}</p>
            <div className="flex flex-col gap-3 text-sm text-[#DCE2EA]">
              <a data-testid="footer-phone" href={AGENCY.phoneHref} className="flex items-center gap-3 hover:text-[#E8E8E8] transition-colors"><Phone size={15} /> {AGENCY.phone}</a>
              <a data-testid="footer-whatsapp" href={waLink("Buongiorno, vorrei informazioni sui vostri immobili.")} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[#E8E8E8] transition-colors"><MessageCircle size={15} /> WhatsApp</a>
              <a data-testid="footer-email" href={`mailto:${AGENCY.email}`} className="flex items-center gap-3 hover:text-[#E8E8E8] transition-colors"><Mail size={15} /> {AGENCY.email}</a>
              <span className="flex items-center gap-3 text-[#8A94A0]"><MapPin size={15} /> {AGENCY.address}</span>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-[#262626] flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#8A94A0]">
          <span>© {new Date().getFullYear()} ROMACASA Intermediazioni Immobiliari — Roma</span>
          <span className="font-mono-d">{t("foot.claim")}</span>
          <Link data-testid="footer-admin-link" to="/admin" className="hover:text-[#E8E8E8] transition-colors">{t("foot.area")}</Link>
        </div>
      </div>
    </footer>
  );
};
